/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rankings_Cat_Limited_DescInputs */



/**
* | output |
* | --- |
* | "In-person Limited (sealed/draft) events: your best 8 results over 18 months." |
*
* @param {Rankings_Cat_Limited_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rankings_cat_limited_desc = /** @type {((inputs?: Rankings_Cat_Limited_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rankings_Cat_Limited_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tournois Limité (scellé/draft) en présentiel : vos 8 meilleurs résultats sur 18 mois.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Torneos Limited (sellado/draft) presenciales: sus 8 mejores resultados en 18 meses.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Torneios Limited (selado/draft) presenciais: seus 8 melhores resultados em 18 meses.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tornei Limited (sealed/draft) in presenza: i tuoi 8 migliori risultati in 18 mesi.")
	return /** @type {LocalizedString} */ ("In-person Limited (sealed/draft) events: your best 8 results over 18 months.")
});